import { createContext, useContext } from 'react';

import { type AdvancedFiltersConfig } from '../advanced-filters';
import { type SavedFilterTemplate } from '../saved-filters';

interface FiltersDrawerContextValue {
  hasSelectedFilters: boolean;
  isDirty: boolean;
  resetFromExternalState: () => void;
  applyLocalState: () => void;
  hydrateFromSavedFilter: (
    viewedSavedFilterId: string,
    savedFilterTemplates: SavedFilterTemplate<AdvancedFiltersConfig>[],
  ) => void;
}

export const FiltersDrawerContext =
  createContext<FiltersDrawerContextValue | null>(null);

export const useFiltersDrawerContext = () => {
  const context = useContext(FiltersDrawerContext);

  if (!context) {
    throw new Error(
      'useFiltersDrawerContext must be used within a FiltersDrawerContext provider',
    );
  }

  return context;
};
